export const ADD_ACCOUNTS_DATA = 'ADD_ACCOUNTS_DATA'
export const ADD_BOXES_DATA = 'ADD_BOXES_DATA'
export const LOAD_TRANSACTION_TYPES = 'LOAD_TRANSACTION_TYPES'
